import React from "react";
import Floaticons from "../function-components/Floaticons";


function Comingsoon() {
    return (
        <>
            <div className="main-banner">
                <img src="images/Home/Enbridgebanner.png" alt="banner" className="banner-img" />
                {/* <img src="images/Home/banner-strip.png" alt="strip" className="strip-img" /> */}
                <div className="announcemnt-box">
                    <p>
                        <img src="images/Home/speaker.png" alt="speaker" className="speaker-img" />
                        <marquee
                            width="92%"
                            direction="left"
                            style={{ display: "inline-block", verticalAlign: "middle" }}
                        >
                            <b>Come Join Us</b> on an exhilarating learning Journey on Enbridge Talent Academy
                            Platform!!!
                        </marquee>
                    </p>
                </div>
                <Floaticons />
                <h2 style={{ textAlign: "center", margin: "1rem", color: "#3a55ea", fontWeight: "bold" }}>Coming Soon !!!</h2>
            </div>
        </>
    );
}

export default Comingsoon;
